export const STEP = {
	GO_TO: 0,
	LOGIN: 1,
};
